import React, { Component } from 'react'
import TableProducts from '../../components/Products/TableProducts';
import { getI18n } from 'react-i18next';

class ListProducts extends Component {
    render() {
        const i18n = getI18n();
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="page-title-box">
                        <div className="row align-items-center">
                            <div className="col-sm-6">
                                <h4 className="page-title">{i18n.t('PRODUCT')}</h4>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item active">{i18n.t('PRODUCT_LIST')}</li>
                                </ol>
                            </div>
                            <div className="col-sm-6">
                            </div>
                        </div>
                    </div>
                    <TableProducts />
                </div>

            </div>
        )
    }
}

export default ListProducts;